import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=34d7d2b5&scoped=true"
import script from "./vModal.vue?vue&type=script&lang=ts"
export * from "./vModal.vue?vue&type=script&lang=ts"
import style0 from "./vModal.vue?vue&type=style&index=0&id=34d7d2b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7d2b5",
  null
  
)

export default component.exports